var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper landing-main"},[_c('landing-top-bar'),_vm._t("default"),_c('landing-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }